/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["button[_ngcontent-%COMP%]{border-radius:9px;margin-right:6px;margin-top:20px}.request-txt[_ngcontent-%COMP%]{font-size:22px;color:#303372;font-weight:700;margin-bottom:1rem}mat-error[_ngcontent-%COMP%]{font-size:13px}[_nghost-%COMP%]     .custom-checkbox .mat-checkbox-layout{white-space:normal}[_nghost-%COMP%]     .custom-checkbox .mat-checkbox-inner-container{margin-right:24px}a[_ngcontent-%COMP%]{color:#000;text-decoration:none;border-bottom:1px dotted #000}"];
export { styles as styles };
